export const SMALL_SCREEN_WIDTH = 599;
export const NORMAL_SCREEN_WIDTH = 959;
export const NORMAL_PLUS_SCREEN_WIDTH = 1199;
